module.exports = __webpack_public_path__ + "static/media/no_matching.f28e85df.png";